import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import { Button, Checkbox, CheckboxGroup, Collapsible, Dropdown, Form, Toast, Input, Modal, Radio, RadioGroup, Upload } from '@douyinfe/semi-ui';
import { Image } from '@douyinfe/semi-ui';
import useRequest from '@/utils/useRequest';
import { Router, useRouter } from 'next/router';
import { IndexContext } from "@/stores";
import classNames from 'classnames';
import { debounce, toArray } from 'lodash';
import useJSEncrypt from '@/utils/useJsEncrypt';
import Head from 'next/head';
import { PRODDOMAIN } from '@/utils';

interface IProps {
}

const Apply: NextPage<IProps> = ({ }) => {
  const router = useRouter() as any
  const { encryptText } = useJSEncrypt()
  // const [prodCate, setProdCate] = useState([])
  const [country, setCountry] = useState([])
  const [region, setRegion] = useState([])
  const [filed, setFiled] = useState([])
  const [cate, setCate] = useState([])
  const [selectCate, setSelectCate] = useState<number[]>([])
  const [selectSubCate, setSelectSubCate] = useState<number[]>([])
  const [companyTypes, setCompanyTypes] = useState([])
  const [checkMap, setCheckMap] = useState({})
  const [city, setCity] = useState([])
  const [visible, setVisible] = useState(false)
  const [isLogo, setIsLogo] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [applyid, setApplyId] = useState()
  const formRef = useRef<any>()
  const areaRef = useRef<any>()
  const checkbox = useRef<any>()
  const { setLang, setIsHeadFoot } = useContext(IndexContext);
  const request = useRequest()
  const [loading, setLoading] = useState(false)

  const btnClick = useCallback(() => {
    const { main_category, logo, belong_name, booth_width, booth_height, ...params } = formRef.current.getFormState().values
    if (!checkbox.current) {
      Toast.error({
        content: 'You must read and agree the “Data protection regulation - exhibitors”',
      })
      return
    }

    if (main_category?.id != 39 && !checkNodes(selectCate, selectSubCate, true)) {
      Toast.error({
        content: 'The specific product category needs to be selected to the subcategory',
      })
      return
    }
    formRef.current.validate().then(async () => {
      if (booth_height * booth_width < 18) {
        Toast.error({
          content: 'Raw Space Min 18㎡',
        })
        return
      }
      // if (isLogo && !logo) {
      //   Toast.error({
      //     content: 'Please enter company logo',
      //   })
      //   return
      // }
      if (main_category?.id != 39 && ![...selectCate, ...selectSubCate].length) {
        Toast.error({
          content: 'Please select at least one specific product category',
        })
        return
      }
      const { data } = await request.post('/api/booth/apply', {
        ...params,
        logo,
        booth_width, booth_height,
        main_category: main_category.id,
        sub_category: main_category.id != 39 ? [...selectCate, ...selectSubCate].join(',') : '',
        belong_name,
        industry_background: belong_name
      })

      if (data?.code == 1) {
        Toast.success({
          content: "Submit successfully",
        })
        formRef.current.reset()
        setSelectCate([])
        setSelectSubCate([])
        setApplyId(data.data.apply_id)
        // window.scrollTo(0, 0)
        return;
      } else {
        Toast.error({
          content: data.msg,
        })
      }

    }).catch((err: any) => {
      Toast.error({
        content: 'Please fill in the complete information',
      })
    })

  }, [selectCate, selectSubCate, isLogo])

  const download = useCallback(async () => {
    if (!applyid) {
      Toast.error({
        content: 'Please submit your application first',
      })
      return
    }
    try {
      setLoading(true);
      const response = await request.get(`/api/booth/proceedings/${applyid}`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'Proceedings.pdf');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('download error:', error);
      alert('File download failed, please check permissions or network.');
    } finally {
      setLoading(false);
    }
  }, [applyid])

  const uploadLogo = useCallback(async (files: any) => {
    if (files[0].size > 1048576) {
      Toast.error({
        content: 'Picture too large',
        duration: 3,
      })
      return
    }
    const key = await encryptText(`smart:${new Date().getTime()}`)
    const { data } = await request('/api/upload/token', {
      params: {
        key
      }
    })
    if (data?.data?.token) {
      const { data: imgData } = await request.post('/api/booth/upload_logo', {
        token: data?.data?.token,
        file: files[0]
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      )
      formRef.current.setValue('logo', imgData?.data?.url)
    }

  }, [formRef.current])

  const transOption = useCallback((arr: any = []) => {
    if (!arr.length) return []
    return arr?.map((item: any) => {
      return {
        ...item,
        childlist: transOption(item.childlist),
        key: item.id,
        value: item.id,
        label: item.name_en || item.name
      }
    })
  }, [])

  const countSelectedLeafNodes = useCallback((selectedIds: number[]) => {
    let leafCount = 0;
    const traverse = (nodes: any) => {
      for (const node of nodes) {
        if (selectedIds.includes(node.value)) {
          if (node.childlist.length === 0) {
            leafCount++;
          } else {
            traverse(node.childlist);
          }
        }
      }
    }
    traverse(cate);

    return leafCount;

  }, [cate])

  const checkNodes = useCallback((parent: any, children: any, isCheck = false) => {
    let arr = parent
    let flag = true

    cate.forEach((item: any) => {
      if (
        parent.includes(item.id)
        && item.childlist.length
        && !item.childlist.some((child: any) => children.includes(child.id))
      ) {
        arr = arr.filter((child: any) => child !== item.id)
        flag = false
      }
    })

    !isCheck && setSelectCate(arr)
    return flag
  }, [cate])

  const findDifference = (arr1: number[], arr2: number[]): number => {
    // 使用 Set 来方便地进行数组差异的计算
    const set2 = new Set(arr2) as any;
    for (const num of arr1) {
      if (!set2.has(num)) {
        return num; // 找到第一个不在arr2中的元素并返回
      }
    }
    return 0
  }

  const clearNodes = useCallback((id: number) => {
    const item = cate.find((item: any) => item.id == id) as any
    const set = new Set(item.childlist?.map((item: any) => item.id))
    const arr = selectSubCate.filter((num: number) => {

      return !set.has(num)
    })
    setSelectSubCate(arr)
  }, [cate, selectSubCate])

  const getCity = useCallback(async (pid: string) => {
    const { data } = await request.get(`/api/region/list`, {
      params: {
        pid
      }
    })
    const arr = transOption(toArray(data?.data?.list))

    setCity(arr)
  }, [])

  const getFiled = useCallback((filed: string) => {
    return formRef.current.getValue(filed)
  }, [formRef.current])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/api/region/data`)
    const { data: info } = await request.get(`/api/setting/info`)
    setFiled(info?.data?.category)
    setCompanyTypes(transOption(Array.from({
      ...info?.data?.company_types,
      length: Object.keys(info?.data?.company_types).length + 1
    }).slice(1) as any))
    setCountry(transOption(data?.data?.country))
    setRegion(transOption(data?.data?.province))

  }, [])

  useEffect(() => {
    setIsHeadFoot(false)
    getData()
    return () => {
      setIsHeadFoot(true)
    }
  }, [])


  return (
    <div>
      <div className={styles.container}>
        <Head>
          <title>Reserve Your Booth | Organic Festa Asia 2025</title>
          <meta name="keywords" content="booth reservation, Organic Festa Asia, 2025 Shanghai organic expo, exhibitor application, organic product showcase" />
          <meta name="description" content="Reserve your booth now at Organic Festa Asia 2025 to showcase your organic products, expand your business network, and gain the latest industry insights." />
        </Head>
        <div className={styles.content}>
          <div className={styles.header}>
            <p><span style={{ color: '#f79700' }}>Organic</span><br />The beauty of sustainable living</p>
            <div className={styles.info}>
              <h1>Organic Festa Asia</h1>
              <p>
                <span className={styles.time}>2025.09.03-05</span>
                <span className={styles.site}>Shanghai New International Expo Center</span>
              </p>
            </div>
            <div className={styles.btns}>
              <a href="https://www.organic-festa.com/">
                <div className={styles.backBtn} style={{ backgroundColor: 'transparent' }}>Return home</div>
              </a>
              {/* <a href="/">
                <div className={styles.backBtn}>Registered,Return to log in</div>
              </a> */}
            </div>
          </div>
          <div className={styles.form}>
            <div className={styles.title}>
              <h2>Exhibitor Registration<span>(Required fields marked with * )</span></h2>
              <Dropdown
                style={{ width: '191px' }}
                render={
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
                    <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
                  </Dropdown.Menu>
                }
              >
                <div className={styles.langBtn}>
                  Language：
                </div>
              </Dropdown>
            </div>
            <Form
              getFormApi={(formApi: any) => formRef.current = formApi}
              labelPosition="left"
              labelWidth="145px"
              labelAlign="right"
            >
              {
                (({ formState, values, formApi }) => (
                  <div>
                    <h3><span>*</span>Booth Type</h3>
                    <div className={classNames([styles.type, 'type'])}>
                      <Form.RadioGroup
                        field="booth_type"
                        label={(<span></span>)}
                        direction='vertical'
                        rules={[
                          { required: true, message: 'Required field' },
                        ]}
                        onChange={() => {
                          formRef.current.reset(['booth_area1', 'booth_area'])
                        }}
                      >
                        <Form.Radio value="1">
                          <div className={styles.radioRight}>
                            <div className={styles.label}>
                              <p>Raw Space<span>/㎡</span></p>
                              <span>Min 18㎡</span>
                            </div>
                            <Form.InputNumber
                              field="booth_width"
                              hideButtons
                              min={1}
                              disabled={getFiled('booth_type') != '1'}
                              placeholder='length'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '1', message: 'Required field' },
                              ]}
                            />
                            <span>*</span>
                            <Form.InputNumber
                              field="booth_height"
                              hideButtons
                              min={1}
                              disabled={getFiled('booth_type') != '1'}
                              placeholder='width'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '1', message: 'Required field' },
                              ]}
                            />
                          </div>
                        </Form.Radio>
                        <Form.Radio value="2" className='standard'>
                          <div className={styles.radioRight}>
                            <div className={classNames([styles.label, styles.standard])}>
                              <p>Standard Booth<span>/㎡</span></p>
                            </div>
                            <Form.Select
                              field={getFiled('booth_type') == '2' ? 'booth_area' : 'booth_area1'}
                              label={(<span></span>)}
                              disabled={getFiled('booth_type') != '2'}
                              placeholder='Please select the booth type'
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '2', message: 'Required field' },
                              ]}
                            >
                              <Form.Select.Option value="9">9</Form.Select.Option>
                              <Form.Select.Option value="12">12</Form.Select.Option>
                              <Form.Select.Option value="18">18</Form.Select.Option>
                            </Form.Select>
                          </div>
                        </Form.Radio>
                      </Form.RadioGroup>
                    </div>
                    <Form.TextArea
                      className='textarea'
                      field="booth_remark"
                      placeholder='Please enter any special construction requirements'
                      label={(<span className={classNames([styles.textAreaLabel])}>Special Construction Requirements</span>)}
                      trigger='blur'
                    />
                    <h3 className={styles.formTitle}>Exhibitor Information</h3>
                    <div className={styles.exhInfo}>
                      <div className={styles.twoCol}>
                        <Form.Select
                          field="main_category"
                          label={(<span className={styles.required}>Main Display Field</span>)}
                          style={{ maxWidth: '383px' }}
                          placeholder='Please select the main display field'
                          trigger='blur'
                          onChangeWithObject
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                          optionList={transOption(filed)}
                          onChange={(option: any) => {
                            setCate(option.childlist)
                            setSelectCate([])
                            setSelectSubCate([])
                          }}
                        >
                          {/* {
                          filed.map((item: any) => (
                            <Form.Select.Option value={item.id}>{item.name_cn}</Form.Select.Option>
                          ))
                        } */}
                        </Form.Select>
                      </div>

                      <Form.Slot label={(
                        <span className={styles.required}>Specific Product Categories</span>
                      )}>
                        <div className={classNames(['slot', styles.proTypes])}>
                          {
                            getFiled('main_category')?.id == 39 ?
                              <Form.Input
                                field="other_category"
                                placeholder='Please enter specific product categories'
                                trigger='blur'
                                rules={[
                                  { required: true, message: 'Required field' },
                                ]}
                              />
                              : <>
                                <p>(Helps your potential customers find you easily. Please select up to 3 items per field.)</p>
                                <CheckboxGroup
                                  onChange={(value: any) => {
                                    const all = [...value, ...selectSubCate]
                                    const count = countSelectedLeafNodes(all)
                                    if (value.length < selectCate.length) {
                                      clearNodes(findDifference(selectCate, value))
                                      setSelectCate(value)
                                      return
                                    }
                                    if (count > 3 || (count === 3 && all.length > 4))
                                      return
                                    setSelectCate(value)
                                  }}
                                  value={selectCate}
                                >
                                  {
                                    cate.map((item: any) => (
                                      <>
                                        <Checkbox
                                          style={{ fontWeight: 'bold' }}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </Checkbox>
                                        {
                                          !!item.childlist.length &&
                                          selectCate
                                            ?.includes(item.value) && (
                                            <CheckboxGroup
                                              value={selectSubCate}
                                              style={{ marginLeft: '30px', gap: '20px 40px' }}
                                              // field={`cate_child_${item.value}`}
                                              onChange={(value: any) => {
                                                const count = countSelectedLeafNodes([...selectCate, ...value])
                                                if (count > 3)
                                                  return
                                                count === 3 && checkNodes(selectCate, value)
                                                setSelectSubCate(value)

                                              }}
                                              options={item.childlist}
                                              direction='horizontal'
                                            />
                                          )
                                        }
                                      </>
                                    ))
                                  }
                                </CheckboxGroup>
                              </>
                          }

                        </div>
                      </Form.Slot>
                      <Form.TextArea
                        className='textarea'
                        field="product_cn"
                        placeholder='Please enter main exhibits information in Chinese'
                        label={(<span className={classNames([styles.textAreaLabel])}>Main Exhibits Information<br className='minHidden' />(Chinese)</span>)}
                      />
                      <Form.TextArea
                        className='textarea'
                        field="product_en"
                        placeholder='Please enter main exhibits information in English'
                        label={(<span className={classNames([styles.textAreaLabel])}>Main Exhibits Information<br className='minHidden' />(English)</span>)}
                      />
                      <div style={{ margin: '10px 0 0' }}>
                        <Form.RadioGroup
                          options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                          style={{ gap: '40px' }}
                          field="is_belong"
                          labelWidth='auto'
                          label={(<span className={styles.required}>Are you a Certification Body/Government Organization/Industry Association?</span>)}
                          direction="horizontal"
                          rules={[
                            { required: true, message: 'Please select Yes or No' },
                          ]}
                        />
                      </div>
                      <div className={styles.company}>
                          <Form.RadioGroup
                            options={companyTypes.map((item: any) => {
                              return {
                                label: item.title_en || item.title_cn,
                                value: item.id
                              }
                            })}
                            style={{ gap: '20px 40px', flexWrap: 'wrap' }}
                            field="company_type"
                            label={(<span>Company Type</span>)}
                            direction="horizontal"
                          />
                      </div>
                      {getFiled('company_type') == 7 && <Form.Input
                        field="company_type_other"
                        label={(<span></span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'Required field' },
                        ]}
                      />}
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="company_en"
                          placeholder='Please enter your company name'
                          label={(<span className={styles.required}>Company Name</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                        />
                      </div>
                      <Form.Slot label={(<span>Company Address</span>)}>
                        <div className={classNames([styles.address, 'slot'])}>
                          <Form.Select
                            field="country_id"
                            label={(<span>Country</span>)}
                            placeholder='Please select the country'
                            onSelect={(value: any, option: any) => {
                              formRef.current.setValue('phone_code', '+' + option.code)
                              setVisible(value == 256)
                            }}
                            optionList={country}
                          >
                          </Form.Select>
                          {/* {(getFiled('country_id') == 256 && <>
                            <Form.Select
                              field="province_id"
                              label={(<></>)}
                              placeholder='Please select the province'
                              rules={[
                                { required: true, message: 'Required field' },
                              ]}
                              optionList={region}
                              onSelect={(value: any, option: any) => {
                                getCity(value)
                                formRef.current.reset(['city_id'])
                              }}
                            />
                            <Form.Select
                              field="city_id"
                              label={(<></>)}
                              placeholder='Please select the city'
                              rules={[
                                { required: true, message: 'Required field' },
                              ]}
                              optionList={city}
                              onSelect={(value: any, option: any) => {
                                formRef.current.setValue('phone_zone', option.area_code)
                              }}
                            />
                          </>)} */}
                        </div>
                      </Form.Slot>
                      <Form.Input
                        field="address"
                        placeholder='Please enter the full address'
                        label={(<></>)}
                      />
                      <div className={styles.twoCol}>
                        {/* <Form.InputNumber
                          field="phone"
                          hideButtons
                          placeholder='请输入公司电话'
                          label={(<span className={styles.required}>联系电话</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                        /> */}
                        <Form.Input
                          field="website"
                          placeholder='If unavailable, please write "None."'
                          label={(<span>Company Website</span>)}
                        />
                      </div>
                      {/* <Form.Input
                        field="com_email"
                        placeholder='请输入公司邮箱'
                        label={(<span className={styles.required}>公司邮箱</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'Required field' },
                          {
                            validator: (rule, value) => {
                              const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              return emailRegex.test(value);
                            }, message: '请输入有效邮箱'
                          }
                        ]}
                        style={{ maxWidth: '383px' }}
                      /> */}
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="contact"
                          placeholder="Please enter the contact person's name"
                          label={(<span className={styles.required}>Contact Person</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                        />
                        <Form.Input
                          field="position"
                          placeholder="Please enter the contact person's position"
                          label={(<span className={styles.required}>Position</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        {/* <Form.InputNumber
                          field="mobile"
                          hideButtons
                          placeholder='请输入手机号码'
                          label={(<span className={styles.required}>手机号码</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                            {
                              validator: (rule, value) => {
                                const regex = /^1[3-9]\d{9}$/;
                                return regex.test(`${value}`);
                              }, message: '请输入有效手机号码'
                            }
                          ]}
                        /> */}
                        <Form.Input
                          field="phone"
                          placeholder='Please enter a valid phone number'
                          label={(<span className={styles.required}>Phone Number</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                          ]}
                        />
                        <Form.Input
                          field="email"
                          placeholder='Please enter an email address'
                          label={(<span className={styles.required}>Email Address</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: 'Required field' },
                            {
                              validator: (rule, value) => {
                                const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                return emailRegex.test(`${value}`);
                              }, message: 'Please enter an valid email address'
                            }
                          ]}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        <Form.Slot label={(
                          <span>Number of Co-Exhibitors (if applicable)</span>
                        )}>
                          <div className='slot'>
                            <Form.InputNumber
                              field="union_count"
                              hideButtons
                              placeholder='Please enter the number of co-exhibitors'
                              min={1}
                              precision={0}
                            />
                          </div>
                        </Form.Slot>
                      </div>
                      {(getFiled('union_count') > 0) && <Form.Slot label={(
                        <span>Co-Exhibitor Names and Contact Information</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('union_company') && <div className={styles.unionPlace} onClick={() => {
                            areaRef.current.focus()
                          }}>
                            <p>Example: Exhibitor Name 1</p>
                            <p>1234545678911</p>
                            <p>Exhibitor Name 2</p>
                            <p>1234545678911</p>
                          </div>}
                          <Form.TextArea
                            ref={areaRef}
                            className='textarea'
                            field="union_company"
                            style={{ height: '160px', backgroundColor: 'transparent' }}
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>}

                      <Form.Slot style={{ margin: '20px 0 0' }} label={(
                        <span
                          // className={classNames({ [styles.required]: isLogo })}
                          style={{}}
                        >Company Logo</span>
                      )}>
                        <Upload
                          action={''}
                          limit={1}
                          uploadTrigger='custom'
                          onFileChange={uploadLogo}
                          // onChange={(props) => setLogo(props.fileList[0].url)}
                          renderFileItem={() => null}
                        // draggable={true}
                        >
                          <div className={styles.upload}>
                            <div className={styles.uploadBox}>
                              {
                                !!getFiled('logo')
                                  ? <Image className={styles.image} src={getFiled('logo')} preview={false} />
                                  : <div className={styles.btn}>Click to upload logo</div>
                              }

                            </div>
                            <p>Logo size: ≤ 2MB, Dimensions: 240x160 pixels, Format: JPG/PNG, Resolution: 300 dpi or below.</p>
                          </div>
                        </Upload>
                      </Form.Slot>
                      {/* <Form.Slot style={{ margin: '15px 0' }}
                        label={(<span>No Logo</span>)}>
                        <Checkbox style={{ marginTop: '10px' }} onChange={(e) => setIsLogo(!isLogo)}>If your company has no logo, please indicate here</Checkbox>
                      </Form.Slot> */}
                      <Form.Slot label={(
                        <span>Company Profile<br className='minHidden' />(Chinese)</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('content_cn') && <div className={styles.intro}>
                            <p>For website display, word limit is flexible</p>
                          </div>}
                          <Form.TextArea
                            className='textarea'
                            field="content_cn"
                            style={{ backgroundColor: 'transparent' }}
                            placeholder='Please enter your company profile in Chinese'
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>
                      <Form.Slot label={(
                        <span>Company Profile<br className='minHidden' />(English)</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('content_en') && <div className={styles.intro}>
                            <p>For website display, word limit is flexible</p>
                          </div>}
                          <Form.TextArea
                            className='textarea'
                            field="content_en"
                            style={{ backgroundColor: 'transparent' }}
                            placeholder='Please enter your company profile in English'
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>
                      <Form.Slot className='belong' label={(
                        <span
                          className={styles.required}
                        >Association and Industry Background</span>
                      )}>
                        <div className='slot'>
                          <Form.Input
                            field="belong_name"
                            placeholder='Please provide information about your association and industry background (or write "None" if not applicable)'
                            label={(<></>)}
                            trigger='blur'
                            rules={[
                              { required: true, message: 'Required field' },
                            ]}
                          />
                          <p style={{ color: '#bbb', fontSize: '14px', lineHeight: '24px' }}>Affiliated Certification Body/Association (or Recommended Unit)</p>
                        </div>
                      </Form.Slot>
                    </div>
                    <h3 className={styles.formTitle}>Financial Information</h3>
                    <div className={styles.finInfo}>
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="invoice_title"
                          placeholder='Please enter the invoice title'
                          label={(<span>Invoice Title</span>)}
                        />
                        <Form.Input
                          field="tax_code"
                          placeholder='Please enter the tax number'
                          label={(<span>Tax Number</span>)}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="bank_name"
                          placeholder='Please enter the bank name'
                          label={(<span>Bank Name</span>)}
                        />
                        <Form.Input
                          field="bank_account"
                          placeholder='Please enter the bank account number'
                          label={(<span>Bank Account Number</span>)}
                        />
                      </div>
                    </div>
                  </div>
                ))
              }
            </Form>

            <div className={styles.footer}>
              <div className={styles.allow}>
                <Checkbox className='is-check' onChange={(e) => checkbox.current = e.target.checked}>
                  <p style={{ color: 'white' }}>I agree to the </p>
                </Checkbox>
                <span onClick={() => setIsOpen(!isOpen)}>Data Protection Regulations for Exhibitors</span>
              </div>
              <Collapsible isOpen={isOpen}>
                <p className={styles.allowText}>
                  I hereby entitle Messe Düsseldorf Shanghai Co. Ltd. (“MDS”) to collect, process, and use the information I provided for the purpose of internal customer management. I am aware that the information I provided will be further transferred to MDS’s offshore group companies (e.g. Messe Düsseldorf GmbH in Germany) as well as external service providers for further process/use. In addition, I entitle MDS and its group companies to send me commercial information (including but not limited to notices, surveys, and exhibitions alert) based on the information I provided to MDS, including but not limited to through Mail, E-mail, SMS/MMS and Telephone Calls.</p>
              </Collapsible>
              <div className={styles.btns}>
                <div className={styles.subBtn} onClick={debounce(() => btnClick(), 500)}>Submit</div>
                <Button
                  className={styles.download}
                  onClick={debounce(() => download(), 500)}
                  loading={loading}
                >Download Proceedings</Button>
              </div>

            </div>
          </div>
        </div>
        <p>Copyright © 2025 杜塞尔多夫展览有限（上海）公司  版权所有 <a href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备13014242号-28</a></p>
      </div >
    </div >
  );
};

export default Apply;
